import { toastr } from 'react-redux-toastr';
import {
    SET_EDITED_ENTITY,
    UPDATE_ENTITY_FIELD,
    REST_COVER_IMAGE_UPLOADED,
    LOGO_IMAGE_UPLOADED,
    MENU_ITEM_IMAGE_UPLOADED,
    SMART_PROMOTION_BANNER_UPLOADED,
    SMART_PROMOTION_BANNER_DELETED
} from '../types';
import api from '../api';
import entities from '../../entities';

export const setEditedEntity = (type = null, entity = null, extra = null) => {
    entity = entities(type, entity);

    return {
        type: SET_EDITED_ENTITY,
        payload: { type, entity, extra },
    };
};

export const editEntityField = (key, value) => {
    return {
        type: UPDATE_ENTITY_FIELD,
        payload: { key, value },
    };
};

export const deleteImage = (key, onSuccess) => {
    return {
        type: SMART_PROMOTION_BANNER_DELETED,
        payload: api.images.delete(key),
        meta: { onSuccess }
    };
};

export const uploadImage = (file, purpose = 'image', mode, onSuccess) => {
    const data = new FormData();
    data.append('file', file);
    data.append('name', file.name);

    return dispatch => {
        if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif')) {
            toastr.error('Not a valid image format');
        } else if(file.size > 800000) {
            toastr.error('Images cannot be more than 800kb');
        } else if(file.size > 350000 && file.type === 'image/png') {
            toastr.error('PNG images cannot be more than 350kb');
        } else {
            dispatchImageUploadByPurpose(dispatch, data, purpose, mode, onSuccess);
        }
    };
};

function dispatchImageUploadByPurpose(dispatch, data, purpose, mode, onSuccess) {
    const purposeTypes = {
        logo: LOGO_IMAGE_UPLOADED,
        restCover: REST_COVER_IMAGE_UPLOADED,
        menuItem: MENU_ITEM_IMAGE_UPLOADED,
        smartPromotionBanner: SMART_PROMOTION_BANNER_UPLOADED
    };

    dispatch({
        type: purposeTypes[purpose],
        payload: api.images.upload(data, purpose, mode),
        meta: { onSuccess }
    });
}